<template>
  <el-dialog title="裁切图片" :visible="dialogVisible" @close="$emit('update:visible',false)" :close-on-click-modal="false"
             :width="width" append-to-body>
    <div class="dialog_conwrap">
      <!-- 遮罩层 -->
      <p class="infoDesc" style="line-height: 24px"><i class="el-icon-warning-outline"></i>图片建议尺寸：{{imgstatus[imgSize].text}}，宽高均小于4000px，文件类型仅支持gif、jpeg、jpg、png，<br>文件大小10M以内，1M以内不压缩，1M以上将压缩至20%大小。
      </p>
      <div class="cropper_body">
        <div class="cropper_left">
          <p class="cropper_titlename">裁剪操作</p>
          <div class="cropperContainer">
            <div class="cropper-line-body">
              <img id="corpperimage" src="/static/img/noneImg.png" alt="Picture">
            </div>
          </div>
        </div>
        <div class="cropper_right" v-if="type != 14">
          <p class="cropper_titlename">裁剪预览</p>
          <div class="preview-body">
            <div class="preview"></div>
          </div>
        </div>
        <div v-else class="cropper_right cropper_img_t6">
          <p class="cropper_titlename">示例效果</p>
          <div class="preview-body">
            <img src="static/img/examplepic.jpg" />
          </div>
        </div>
      </div>
      <div style="height: 0;overflow: hidden;">
        <div style="margin-top:20px;text-align: left;">
          <input type="file" id="change" accept="image" @change="change">
          <label for="change"></label>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer f-footer">
      <span class="f-footer-l">
        <el-button class="uploadImgIcon" @click="chooseImg" size="small">上传 <i class="el-icon-upload"></i></el-button>
        <el-button icon="el-icon-plus" @click="zoomFn(0)" size="small"></el-button>
        <el-button icon="el-icon-minus" @click="zoomFn(1)" size="small"></el-button>
        <el-button icon="el-icon-refresh-right" @click="rotateFn(0)" size="small"></el-button>
        <el-button icon="el-icon-refresh-left" @click="rotateFn(1)" size="small"></el-button>
      </span>
      <span class="f-footer-r">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="commit" size="small" :disabled="disabled">确 定</el-button>
      </span>
    </span>
  </el-dialog>
</template>
<script>
  import Cropper from "cropperjs";
  import api from '@/api.js';
  // 名片封面

  export default {
    name: "corpperLebel",
    props: ["visible","imgSize","type"],
    data() {
      return {
        width: '750px',
        dialogVisible: this.visible,
        picValue: "",
        cropper: "",
        croppable: false,
        panel: false,
        url: "/",
        imgCropperData: {
          accept: "image/gif, image/jpeg, image/png, image/jpg"
        },
        imgstatus:[
          {text:'640*640',long:640,wide:640}, // 0 商品轮播图
          {text:'710*1048',long:710,wide:1048}, // 1 官网装修 图片组件
          {text:'710*1048',long:710,wide:1048}, // 2 官网装修 轮播组件
          {text:'690*367',long:690,wide:367}, // 3 商城配置 基础设置轮播图
          {text:'750*220',long:750,wide:220}, // 4 商城配置 基础设置背景图
          {text:'686*430',long:686,wide:430}, // 5 动态管理动态编辑
          {text:'100*100',long:100,wide:100}, // 6 官网装修企业咨询
          {text:'750*668',long:750,wide:668}, // 7 动态管理动态设置
          {text:'1080*1620',long:1080,wide:1620}, // 8 设置启动图片
          {text:'702*960',long:702,wide:960}, // 9 官网装修 产品简介 702×960
          {text:'280*330',long:280,wide:330}, // 10 官网装修 管理团队 280x330
          {text:'210*90',long:210,wide:90}, // 11 官网装修 管理团队 210x90
          {text:'670*1006',long:670,wide:1006}, // 12 宣传册 自定义背景 
          {text:'750*1280',long:750,wide:1280}, // 13 宣传册 封面图
          {text:'690*208',long:690,wide:208},  // 14 tuoke小程序营销活动封面图
          {text:'336*336',long:336,wide:336},  // 15 企业相册封面图
          {text:'500*400',long:500,wide:400},  // 16 大转盘活动分享图标
          {text:'355*150',long:355,wide:150},  // 17 微信分享
          {text:'750*320',long:750,wide:320},  // 18 预约表单封面图

        ],
        disabled: true,
        imgType: 0
      }
    },
    created() {
      // console.log('进入页面裁切',this.imgSize)
    },
    mounted() {
      //初始化这个裁剪框
      this.$nextTick(function () {
        let self = this;
        let image = document.getElementById("corpperimage");
        self.cropper = new Cropper(image, {
          modal: true, // 黑色低层
          guides: false, // 虚线
          highlight: false,
          aspectRatio: this.imgstatus[this.imgSize].long / this.imgstatus[this.imgSize].wide, // 710*1048
          autoCropArea: 1,
          dragMode: 'move',
          viewMode: 2,
          zoomable: true,
          zoomOnWheel: true,
          preview: '.preview',
          rotatable: true, // 启用旋转图像
          scalable: true, // 启用缩放图像
          autoCrop: false,
          ready() {
            self.croppable = true;
          },
          crop(event) {
            // 画布更改执行
          }
        });
      })
    },
    methods: {
      // 选择图片
      chooseImg() {
        document.getElementById('change').click()
      },
      //取消上传
      cancel() {
        this.panel = false;
        let obj = document.getElementById('change');
        obj.outerHTML = obj.outerHTML;
      },
      //创建url路径
      getObjectURL(file) {
        let url = null;
        if (window.createObjectURL != undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.URL != undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }
        return url;
      },
      zoomFn(option) {
        if (option === 1) {
          this.cropper.zoom(-0.1);
        } else {
          this.cropper.zoom(0.1);
        }
      },
      rotateFn(option) {
        if (option === 0) {
          this.cropper.rotate(90);
        } else {
          this.cropper.rotate(-90);
        }
      },
      change(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        let type = files[0].type; //文件的类型，判断是否是图片
        let size = files[0].size; //文件的大小，判断图片的大小
        if (type == 'image/png') {
          this.imgType = 1;
        }
        if (this.imgCropperData.accept.indexOf(type) == -1) {
          return false;
        }
        if (size > 10485760) {
          this.$message.error('上传图片大小不能超过 10MB!')
          return false;
        }

        this.picValue = files[0];
        this.url = this.getObjectURL(this.picValue);
        this.disabled = false;
        //每次替换图片要重新得到新的url
        if (this.cropper) {
          this.cropper.replace(this.url);
        }

        let image = document.getElementById("corpperimage");
        image.addEventListener('ready', function () {
          this.cropper.crop();
        });
        this.panel = true;
      },
      //确定提交
      commit() {
        this.panel = false;
        let croppedCanvas;
        if (!this.croppable) {
          return;
        }

        croppedCanvas = this.cropper.getCroppedCanvas();
        // Round
        // roundedCanvas = this.getRoundedCanvas(croppedCanvas);
        // this.headerImage = roundedCanvas.toDataURL();
        if (!HTMLCanvasElement.prototype.toBlob) {
          Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
              var canvas = this;
              setTimeout(function () {
                var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
                var len = binStr.length;
                var arr = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                  arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || 'image/jpeg' }));
              });
            }
          });
        }  
        if (this.imgType == 1) {
          this.cropper.getCroppedCanvas().toBlob((blob) => {
            const formData = new FormData();
            formData.append('file', blob);
            formData.append("token",sessionStorage.getItem("token"))
            this.axios
                .post(api.uploadTokenImg, formData)
                .then(response => {
                  if (response.data.code == 0) {
                    this.$emit('imgAddBack',response.data.path)
                    this.dialogVisible = false
                  } 
                })
                .catch(response => {
                });
          }, 'image/png');
        } else {
          this.cropper.getCroppedCanvas().toBlob((blob) => {
            const formData = new FormData();
            formData.append('file', blob);
            formData.append("token",sessionStorage.getItem("token"))
            this.axios
                .post(api.uploadTokenImg, formData)
                .then(response => {
                  if (response.data.code == 0) {
                    this.$emit('imgAddBack',response.data.path)
                    this.dialogVisible = false
                  } 
                })
                .catch(response => {
                });
          }, 'image/jpeg');
        }
      }
    }
  };
</script>
<style>
  .f-footer {
    display: flex;
  }

  .f-footer-l {
    flex: 1;
    text-align: left;
  }

  .uploadImgIcon {
    background: #29A7F4;
    color: #fff;
    border: 1px solid #29A7F4;
  }

  .cropper_body {
    display: flex;
  }


  .cropper_right {
    margin-left: 10px;
  }

  .cropper_titlename {
    height: 40px;
    line-height: 40px;
  }

  .preview {
    width: 350px;
    height: 350px;
    overflow: hidden;
    margin: 0 auto;
  }

  .preview-body {
    width: 350px;
    height: 350px;
    background: #eee;
  }

  .infoDesc {
    color: red;
  }

  * {
    margin: 0;
    padding: 0;
  }

  .cropper-img-body {
    width: 400px;
    height: 400px;
  }

  #demo #button {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 80px;
    height: 40px;
    border: none;
    border-radius: 5px;
    background: white;
  }

  #demo .show {
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: relative;
    /*border-radius: 50%;*/
    border: 1px solid #d5d5d5;
  }

  #demo .picture {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .cropper-line-body {
    width: 350px;
    height: 350px;
  }

  #demo #image {
    max-width: 100%;
  }

  #corpperimage {
    max-width: 100%;
  }

  /*!
   * Cropper.js v1.0.0-rc
   * https://github.com/fengyuanchen/cropperjs
   *
   * Copyright (c) 2017 Fengyuan Chen
   * Released under the MIT license
   *
   * Date: 2017-03-25T12:02:21.062Z
   */
  .cropper-container {
    font-size: 0;
    line-height: 0;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    direction: ltr;
    -ms-touch-action: none;
    touch-action: none
  }

  .cropper-container img {
    display: block;
    min-width: 0 !important;
    max-width: none !important;
    min-height: 0 !important;
    max-height: none !important;
    width: 100%;
    height: 100%;
    image-orientation: 0deg
  }

  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .cropper-wrap-box {
    overflow: hidden;
  }

  .cropper-drag-box {
    opacity: 0;
    background-color: #fff;
  }

  .cropper-modal {
    opacity: .5;
    background-color: #000;
  }

  .cropper-view-box {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
  }

  .cropper-dashed {
    position: absolute;
    display: block;
    opacity: .5;
    border: 0 dashed #eee
  }

  .cropper-dashed.dashed-h {
    top: 33.33333%;
    left: 0;
    width: 100%;
    height: 33.33333%;
    border-top-width: 1px;
    border-bottom-width: 1px
  }

  .cropper-dashed.dashed-v {
    top: 0;
    left: 33.33333%;
    width: 33.33333%;
    height: 100%;
    border-right-width: 1px;
    border-left-width: 1px
  }

  .cropper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    opacity: .75
  }

  .cropper-center:before,
  .cropper-center:after {
    position: absolute;
    display: block;
    content: ' ';
    background-color: #eee
  }

  .cropper-center:before {
    top: 0;
    left: -3px;
    width: 7px;
    height: 1px
  }

  .cropper-center:after {
    top: -3px;
    left: 0;
    width: 1px;
    height: 7px
  }

  .cropper-face,
  .cropper-line,
  .cropper-point {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    opacity: .1;
  }

  .cropper-face {
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .cropper-line {
    background-color: #39f
  }

  .cropper-line.line-e {
    top: 0;
    right: -3px;
    width: 5px;
    cursor: e-resize
  }

  .cropper-line.line-n {
    top: -3px;
    left: 0;
    height: 5px;
    cursor: n-resize
  }

  .cropper-line.line-w {
    top: 0;
    left: -3px;
    width: 5px;
    cursor: w-resize
  }

  .cropper-line.line-s {
    bottom: -3px;
    left: 0;
    height: 5px;
    cursor: s-resize
  }

  .cropper-point {
    width: 5px;
    height: 5px;
    opacity: .75;
    background-color: #39f
  }

  .cropper-point.point-e {
    top: 50%;
    right: -3px;
    margin-top: -3px;
    cursor: e-resize
  }

  .cropper-point.point-n {
    top: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: n-resize
  }

  .cropper-point.point-w {
    top: 50%;
    left: -3px;
    margin-top: -3px;
    cursor: w-resize
  }

  .cropper-point.point-s {
    bottom: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: s-resize
  }

  .cropper-point.point-ne {
    top: -3px;
    right: -3px;
    cursor: ne-resize
  }

  .cropper-point.point-nw {
    top: -3px;
    left: -3px;
    cursor: nw-resize
  }

  .cropper-point.point-sw {
    bottom: -3px;
    left: -3px;
    cursor: sw-resize
  }

  .cropper-point.point-se {
    right: -3px;
    bottom: -3px;
    width: 20px;
    height: 20px;
    cursor: se-resize;
    opacity: 1
  }

  @media (min-width: 768px) {
    .cropper-point.point-se {
      width: 15px;
      height: 15px
    }
  }

  @media (min-width: 992px) {
    .cropper-point.point-se {
      width: 10px;
      height: 10px
    }
  }

  @media (min-width: 1200px) {
    .cropper-point.point-se {
      width: 5px;
      height: 5px;
      opacity: .75
    }
  }

  .cropper-point.point-se:before {
    position: absolute;
    right: -50%;
    bottom: -50%;
    display: block;
    width: 200%;
    height: 200%;
    content: ' ';
    opacity: 0;
    background-color: #39f
  }

  .cropper-invisible {
    opacity: 0;
  }

  .cropper-bg {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
  }

  .cropper-hide {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
  }

  .cropper-hidden {
    display: none !important;
  }

  .cropper-move {
    cursor: move;
  }

  .cropper-crop {
    cursor: crosshair;
  }

  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
</style>


